import {memo, useState} from 'react';

import styled from 'styled-components';
import {useSelector} from 'react-redux';

import {flexColumn} from '~/shared/theme/FlexLayout';
import {useIsMaxMobile} from '~/shared/hooks/deviceInfo';
import BottomSheet from '~/shared/components/BottomSheet';
import {selectMenuHasAdditionalInfo} from '~/shared/store/selectors';

import type {DishType} from '../../modals/DishType';

import Header from './Header';
import PickingOptions from './PickingOptions';
import Footer from './Footer';
import AdditionalInfo from './AdditionalInfo';

const ModalRoot = styled.div`
  height: 100%;
  width: 100%;
  background-color: ${({theme}) => theme.loginModal.backgroundColor};
  border-radius: 2px;
  overflow: auto;
  z-index: 1;
  ${flexColumn};

  &&& {
    max-height: 100dvh;
    background: ${({theme}) => theme.colors.surface};
  }
`;

const DishFormContent = ({onAddToCart, onRemoveDish, dish, isEditMode}: {onAddToCart: () => void; onRemoveDish: () => void; dish: DishType; isEditMode: boolean}) => {
  const [isAdditionalInfoModeActive, setIsAdditionalInfoModeActive] = useState(false);
  const hasAdditionalInfo = useSelector(selectMenuHasAdditionalInfo);

  const isMaxMobile = useIsMaxMobile();

  const onAdditionalInfoClick = () => {
    setIsAdditionalInfoModeActive(true);
  };
  
  const onBackToDishPreviewClick = () => {
    setIsAdditionalInfoModeActive(false);
  };

  return (
    <ModalRoot>
      {isAdditionalInfoModeActive && !isMaxMobile ? (
        <AdditionalInfo onBackClick={onBackToDishPreviewClick} dishName={dish.dishName} itemId={dish.dishId} withBackButton />
      ) : (
        <>
          <Header
            name={dish.dishName}
            description={dish.dishDescription}
            image={dish.dishImageUrl}
            ageRestricted={dish.ageRestricted}
            pricePerMeasurementUnit={dish.pricePerMeasurementUnit}
            measurementUnitScale={dish.measurementUnitScale}
            measurementUnit={dish.measurementUnit}
            onAdditionalInfoClick={hasAdditionalInfo ? onAdditionalInfoClick : undefined}
            showHighSugarAlert={dish.hasHighSugar}
            showHighSaturatedFatAlert={dish.hasHighSaturatedFat}
            showHighSodiumAlert={dish.hasHighSodium}
            alcoholPercentage={dish.alcoholPercentage}
            hasAdditionalInfo={hasAdditionalInfo}
          />

          <PickingOptions choices={dish.choices} selectedChoices={dish.selectedChoices} />

          <Footer
            enableComment={dish.enableComment}
            isEditMode={isEditMode}
            onAddToCart={onAddToCart}
            onRemoveDish={onRemoveDish}
          />
        </>
      )}
      {isMaxMobile && (
        <BottomSheet isOpen={isAdditionalInfoModeActive} onClose={onBackToDishPreviewClick}>
          <AdditionalInfo dishName={dish.dishName} itemId={dish.dishId} onClose={onBackToDishPreviewClick} />
        </BottomSheet>
      )}
    </ModalRoot>
  );

};

export default memo(DishFormContent);
